import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import { SimpleSlider } from "@totalsoft/rocket-webapp-components-deprecated";

const SimpleSliderWrapper = ({ value, onChange, ...props }) => {
  const [localValue, setLocalValue] = useState(value ?? 0);
  const isDraggingRef = useRef(false);

  useEffect(() => {
    if (!isDraggingRef.current) setLocalValue(value ?? 0);
  }, [value]);

  const handleEvent = useCallback(
    (e, v, committed = false) => {
      isDraggingRef.current = !committed;
      !committed && setLocalValue(v);
      onChange(e, v);
    },
    [onChange]
  );

  const handleChange = useCallback((e, v) => handleEvent(e, v, !e), [handleEvent]);
  const handleChangeCommitted = useCallback((e, v) => handleEvent(e, v, true), [handleEvent]);

  return (
    <SimpleSlider {...props} value={localValue} onChange={handleChange} onChangeCommitted={handleChangeCommitted} />
  );
};

SimpleSliderWrapper.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SimpleSliderWrapper;
